import React, { useState } from "react";

/**
 * Threshold input for "minimum tokens to join". Two modes:
 *   - Tokens: raw whole-token count
 *   - Percent: % of total supply (auto-converts to tokens)
 *
 * Backend stores raw whole-token count; this component always emits that.
 * Pass `supplyWhole` (whole-token total supply) so percent → token math
 * works. If supply is unknown, the percent toggle is disabled.
 */
const round = (n, dp = 4) => {
  if (!Number.isFinite(n)) return 0;
  const f = 10 ** dp;
  return Math.round(n * f) / f;
};

export default function MinHoldInput({ value, onChange, symbol, supplyWhole, disabled }) {
  const [mode, setMode] = useState("tokens"); // "tokens" | "percent"

  const tokens = Number(value) || 0;
  const percentOfSupply = supplyWhole > 0 ? (tokens / supplyWhole) * 100 : 0;

  const setTokens = (n) => onChange(Math.max(0, Number(n) || 0));
  const setPercent = (p) => {
    const pct = Math.max(0, Number(p) || 0);
    if (supplyWhole > 0) {
      // Floor to a whole token so the resulting threshold is exact when
      // the on-chain check happens.
      onChange(Math.floor((pct / 100) * supplyWhole));
    }
  };

  return (
    <div className="pm-minhold">
      <div className="pm-minhold__toggle">
        <button
          type="button"
          className={`pm-minhold__seg${mode === "tokens" ? " is-active" : ""}`}
          onClick={() => setMode("tokens")}
        >
          Tokens
        </button>
        <button
          type="button"
          className={`pm-minhold__seg${mode === "percent" ? " is-active" : ""}`}
          onClick={() => setMode("percent")}
          disabled={!supplyWhole}
          title={supplyWhole ? "" : "Supply unknown"}
        >
          Percent
        </button>
      </div>
      {mode === "tokens" ? (
        <input
          type="number"
          className="pm-group__create-input"
          min="0"
          step="any"
          placeholder={`0 ${symbol ? "$" + symbol : ""}`}
          value={tokens || ""}
          onChange={(e) => setTokens(e.target.value)}
          disabled={disabled}
        />
      ) : (
        <input
          type="number"
          className="pm-group__create-input"
          min="0"
          step="any"
          max="100"
          placeholder="0%"
          value={round(percentOfSupply, 4) || ""}
          onChange={(e) => setPercent(e.target.value)}
          disabled={disabled || !supplyWhole}
        />
      )}
      <span className="pm-group__create-hint">
        {tokens > 0 ? (
          <>
            {tokens.toLocaleString()} {symbol ? `$${symbol}` : "tokens"}
            {supplyWhole > 0 && ` · ${round(percentOfSupply, 4)}% of supply`}
            {percentOfSupply >= 1 && (
              <span className="pm-minhold__whale"> · WHALES tier</span>
            )}
          </>
        ) : (
          "0 means anyone can join (still wallet-verified)."
        )}
      </span>
    </div>
  );
}
